import {doRequest} from '../../../helpers/network';
import {REQUEST_TYPE} from '../../../constants';
import {Finance} from '../../../helpers/Urls';

const INITIAL_STATE = {
  isFetching: false,
  hasError: false,
  error: '',
  gpsIds: [],
  recentIds: [],
  counts: {},
  vendor_filter_data: [],
  paymentMappingData: [],
  billDetails: [],
  payoutHistoryData: [],
  phFetching: false,
  directPayoutData: [],
  dpFetching: false,
  directPhFetching: false,
  directPayoutHistoryData: [],
  directPhFetchingFilter: false,
  directPayoutHistoryDataFilter: [],
  //passbook
  fetchPartnerPassbookDetails: false,
  partnerPassbookData: {},
  fetchingPassbookData: false,
  sendToPassbookData: [],
  sendToLoader: false,
  addingCreditOrDebit: false,
};

const FETCH_DATA = 'FETCH_DATA';
const FETCH_PH_DATA = 'FETCH_PH_DATA';
const PH_DATA = 'PH_DATA';
const FETCH_PH_DATA_FAILED = 'FETCH_PH_DATA_FAILED';

const DIRECT_FETCH_PH_DATA = 'DIRECT_FETCH_PH_DATA';
const DIRECT_PH_DATA = 'DIRECT_PH_DATA';
const DIRECT_PH_DATA_FAILED = 'DIRECT_PH_DATA_FAILED';

const DIRECT_FETCH_PH_DATA_FILTER = 'DIRECT_FETCH_PH_DATA_FILTER';
const DIRECT_PH_DATA_FILTER = 'DIRECT_PH_DATA_FILTER';
const DIRECT_PH_DATA_FILTER_FAILED = 'DIRECT_PH_DATA_FILTER_FAILED';

const GET_PARTNER_PASSBOOK_DETAILS = 'GET_PARTNER_PASSBOOK_DETAILS';
const GET_PARTNER_PASSBOOK_DETAILS_SUCCESSFUL =
  'GET_PARTNER_PASSBOOK_DETAILS_SUCCESSFUL';
const GET_PARTNER_PASSBOOK_DETAILS_FAILED =
  'GET_PARTNER_PASSBOOK_DETAILS_FAILED';

const FETCH_DP_DATA = 'FETCH_DP_DATA';
const DP_DATA = 'DP_DATA';
const DP_DATA_FAILED = 'DP_DATA_FAILED';

const FETCH_DP_POST_DATA = 'FETCH_DP_POST_DATA';
const DP_POST_DATA = 'DP_POST_DATA';
const BILLDETAILS = 'BILLDETAILS';
const PAYMENT_DATA = 'PAYMENT_DATA';
const FETCH_SUBMIT_POST_DATA = 'FETCH_SUBMIT_POST_DATA';
const SUBMIT_POST_DATA = 'SUBMIT_POST_DATA';

const FETCH_PASSBOOK_DATA = 'FETCH_PASSBOOK_DATA';
const FETCH_PASSBOOK_DATA_COMPLETED = 'FETCH_PASSBOOK_DATA_COMPLETED';
const FETCH_PASSBOOK_DATA_FAILED = 'FETCH_PASSBOOK_DATA_FAILED';

const GET_PASSBOOK_BALANCES_DATA = 'GET_PASSBOOK_BALANCES_DATA';
const GET_PASSBOOK_BALANCES_DATA_COMPLETED =
  'GET_PASSBOOK_BALANCES_DATA_COMPLETED';
const GET_PASSBOOK_BALANCES_DATA_FAILED = 'GET_PASSBOOK_BALANCES_DATA_FAILED';

const SEND_PASSBOOK_DATA = 'SEND_PASSBOOK_DATA';
const SEND_PASSBOOK_DATA_COMPLETED = 'SEND_PASSBOOK_DATA_COMPLETED';
const SEND_PASSBOOK_DATA_FAILED = 'SEND_PASSBOOK_DATA_FAILED';

const SAVE_CUSTOM_FILTER_VIEW = 'SAVE_CUSTOM_FILTER_VIEW';
const SAVE_CUSTOM_FILTER_VIEW_COMPLETED = 'SAVE_CUSTOM_FILTER_VIEW_COMPLETED';
const SAVE_CUSTOM_FILTER_VIEW_FAILED = 'SAVE_CUSTOM_FILTER_VIEW_FAILED';

const UPDATE_CUSTOM_FILTER_VIEW = 'UPDATE_CUSTOM_FILTER_VIEW';
const UPDATE_CUSTOM_FILTER_VIEW_COMPLETED =
  'UPDATE_CUSTOM_FILTER_VIEW_COMPLETED';
const UPDATE_CUSTOM_FILTER_VIEW_FAILED = 'UPDATE_CUSTOM_FILTER_VIEW_FAILED';

const DELETE_CUSTOM_FILTER_VIEW = 'DELETE_CUSTOM_FILTER_VIEW';
const DELETE_CUSTOM_FILTER_VIEW_COMPLETED =
  'DELETE_CUSTOM_FILTER_VIEW_COMPLETED';
const DELETE_CUSTOM_FILTER_VIEW_FAILED = 'DELETE_CUSTOM_FILTER_VIEW_FAILED';

const STP_SEND_PASSBOOK_DATA = 'STP_SEND_PASSBOOK_DATA';
const STP_SEND_PASSBOOK_DATA_COMPLETED = 'STP_SEND_PASSBOOK_DATA_COMPLETED';
const STP_SEND_PASSBOOK_DATA_FAILED = 'STP_SEND_PASSBOOK_DATA_FAILED';

const GET_REFRESH_ORDER_DETAILS_DATA = 'GET_REFRESH_ORDER_DETAILS_DATA';
const GET_REFRESH_ORDER_DETAILS_DATA_COMPLETED =
  'GET_REFRESH_ORDER_DETAILS_DATA_COMPLETED';
const GET_REFRESH_ORDER_DETAILS_DATA_FAILED =
  'GET_REFRESH_ORDER_DETAILS_DATA_FAILED';

// ADVANCE_PROCESS
const HOLD_PARTNER_PASSBOOK_PAYMENT = 'HOLD_PARTNER_PASSBOOK_PAYMENT';
const HOLD_PARTNER_PASSBOOK_PAYMENT_COMPLETED =
  'HOLD_PARTNER_PASSBOOK_PAYMENT_COMPLETED';
const HOLD_PARTNER_PASSBOOK_PAYMENT_FAILED =
  'HOLD_PARTNER_PASSBOOK_PAYMENT_FAILED';

const ADD_PASSBOOK_CREDIT_OR_DEBIT = 'ADD_PASSBOOK_CREDIT_OR_DEBIT';
const ADD_PASSBOOK_CREDIT_OR_DEBIT_COMPLETED =
  'ADD_PASSBOOK_CREDIT_OR_DEBIT_COMPLETED';
const ADD_PASSBOOK_CREDIT_OR_DEBIT_FAILED =
  'ADD_PASSBOOK_CREDIT_OR_DEBIT_FAILED';

const GET_EXTERNAL_PAYMENT_PARTY = 'GET_EXTERNAL_PAYMENT_PARTY';
const GET_EXTERNAL_PAYMENT_PARTY_COMPLETED =
  'GET_EXTERNAL_PAYMENT_PARTY_COMPLETED';
const GET_EXTERNAL_PAYMENT_PARTY_FAILED = 'GET_EXTERNAL_PAYMENT_PARTY_FAILED';

const PAY_EXTERNAL_PARTY = 'PAY_EXTERNAL_PARTY';
const PAY_EXTERNAL_PARTY_COMPLETED = 'PAY_EXTERNAL_PARTY_COMPLETED';
const PAY_EXTERNAL_PARTY_FAILED = 'PAY_EXTERNAL_PARTY_FAILED';

export const GET_ADJUSTMENT_SUMMARY_REQUEST = 'GET_ADJUSTMENT_SUMMARY_REQUEST';
export const GET_ADJUSTMENT_SUMMARY_SUCCESS = 'GET_ADJUSTMENT_SUMMARY_SUCCESS';
export const GET_ADJUSTMENT_SUMMARY_FAILURE = 'GET_ADJUSTMENT_SUMMARY_FAILURE';

export const DOWNLOAD_ADJUSTMENT_SUMMARY_REQUEST =
  'DOWNLOAD_ADJUSTMENT_SUMMARY_REQUEST';
export const DOWNLOAD_ADJUSTMENT_SUMMARY_SUCCESS =
  'DOWNLOAD_ADJUSTMENT_SUMMARY_SUCCESS';
export const DOWNLOAD_ADJUSTMENT_SUMMARY_FAILURE =
  'DOWNLOAD_ADJUSTMENT_SUMMARY_FAILURE';

export const GET_VENDOR_ORDERS_REQUEST = 'GET_VENDOR_ORDERS_REQUEST';
export const GET_VENDOR_ORDERS_SUCCESS = 'GET_VENDOR_ORDERS_SUCCESS';
export const GET_VENDOR_ORDERS_FAILURE = 'GET_VENDOR_ORDERS_FAILURE';

export const RESET_VENDOR_ORDERS = 'RESET_VENDOR_ORDERS';

export const openMyModal = (data) => {
  return async (dispatch) => {
    dispatch({
      type: data,
    });
  };
};

export const postDirectPayout = (_data, id) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_DP_POST_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: `finance/additional-charges-payouts`,
        data: _data,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: DP_POST_DATA,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
      }
    } catch (err) {}
    return response;
  };
};

export const submitPayout = (_data, id) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_SUBMIT_POST_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: `finance/validate-vpa`,
        data: _data,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: SUBMIT_POST_DATA,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
      }
    } catch (err) {}
    return response;
  };
};

export const getDirectPayout = (id) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_DP_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: id
          ? `finance/additional-charges-payouts?trip_id=${id}`
          : 'finance/additional-charges-payouts',
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: DP_DATA,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: DP_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: DP_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

// export const getPayoutHistory = (id) => {
//   return async (dispatch) => {
//     let response = {};
//     try {
//       dispatch({type: FETCH_PH_DATA});
//       response = await doRequest({
//         method: REQUEST_TYPE.GET,
//         url: `finance/payout-history?trip_id=${id}`,
//       });
//       const {data, status} = response || {};
//       if (status) {
//         dispatch({
//           type: PH_DATA,
//           payload: data,
//         });
//       } else {
//         const {message = 'Service Error'} = response || {};
//       }
//     } catch (err) {}
//     return response;
//   };
// };

export const getPayoutHistory = (value, id) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_PH_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: `finance/payout-history?direct_payout=${value}&trip_id=${id}`,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: PH_DATA,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: FETCH_PH_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_PH_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const getDirectPayoutHistory = (value, id) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: DIRECT_FETCH_PH_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: `finance/payout-history?direct_payout=${value}&vpa=${id}`,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: DIRECT_PH_DATA,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: DIRECT_PH_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: DIRECT_PH_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const getDirectPayoutHistoryFilter = (value, id, search) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: DIRECT_FETCH_PH_DATA_FILTER});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        // url: `finance/payout-history?direct_payout=${value}&vpa=${id}`,
        url: `finance/payout-history?direct_payout=${value}&vpa=${id}&status=${search}`,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: DIRECT_PH_DATA_FILTER,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: DIRECT_PH_DATA_FILTER_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: DIRECT_PH_DATA_FILTER_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const getPaymentData = (id) => {
  return async (dispatch) => {
    let response = {};
    let if_Id = id ? `?id=${id}` : '';
    try {
      dispatch({type: FETCH_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: `finance/get-advance-payment/${if_Id}`,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: PAYMENT_DATA,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
      }
    } catch (err) {}
    return response;
  };
};

export const getBillDetails = (id) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: `finance/get-bill-details?bill_id=${id}`,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: BILLDETAILS,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
      }
    } catch (err) {}
    return response;
  };
};

export const postPaymentMapping = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: 'finance/get-advance-payment',
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
      } else {
        const {message = 'Service Error'} = response || {};
      }
    } catch (err) {}
    return response;
  };
};

export const getExternalPaymentParty = (tab, page, search = '') => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: GET_EXTERNAL_PAYMENT_PARTY});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: `/finance/external-payment-party/?tab=${tab}&page=${page}${search}`,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: GET_EXTERNAL_PAYMENT_PARTY_COMPLETED,
          payload: {
            tab,
            data,
          },
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: GET_EXTERNAL_PAYMENT_PARTY_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: GET_EXTERNAL_PAYMENT_PARTY_FAILED,
        payload: {error: err.message},
      });
    }

    return response;
  };
};

export const payExternalParty = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: PAY_EXTERNAL_PARTY});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Finance.payExternalPaymentPartyURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: PAY_EXTERNAL_PARTY_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: PAY_EXTERNAL_PARTY_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: PAY_EXTERNAL_PARTY_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

//refresh order details:
export const getRefreshOrderDetailsData = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: GET_REFRESH_ORDER_DETAILS_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Finance.getRefreshOrderDetailsDataURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: GET_REFRESH_ORDER_DETAILS_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: GET_REFRESH_ORDER_DETAILS_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: GET_REFRESH_ORDER_DETAILS_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

//passbook
export const getPartnerPassbookDetails = (id, page, search) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: GET_PARTNER_PASSBOOK_DETAILS});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: `finance/passbook/?vendor_id=${id}&page=${page}${search}`,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: GET_PARTNER_PASSBOOK_DETAILS_SUCCESSFUL,
          payload: {...data, search},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: GET_PARTNER_PASSBOOK_DETAILS_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: GET_PARTNER_PASSBOOK_DETAILS_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const getPassbookData = (queryParams) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: FETCH_PASSBOOK_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Finance.getPassbookDataURL(queryParams),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: FETCH_PASSBOOK_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: FETCH_PASSBOOK_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: FETCH_PASSBOOK_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const saveCustomFilterView = (payload) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SAVE_CUSTOM_FILTER_VIEW});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Finance.customFilterViewURL(),
        data: payload,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: SAVE_CUSTOM_FILTER_VIEW_COMPLETED,
          payload: {submitted: payload, data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: SAVE_CUSTOM_FILTER_VIEW_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SAVE_CUSTOM_FILTER_VIEW_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const updateCustomFilterView = (id, payload) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: UPDATE_CUSTOM_FILTER_VIEW});
      response = await doRequest({
        method: REQUEST_TYPE.PATCH,
        url: Finance.customFilterViewURL(),
        data: {id, ...payload},
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: UPDATE_CUSTOM_FILTER_VIEW_COMPLETED,
          payload: {id, submitted: payload, data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: UPDATE_CUSTOM_FILTER_VIEW_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: UPDATE_CUSTOM_FILTER_VIEW_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const deleteCustomFilterView = (id) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: DELETE_CUSTOM_FILTER_VIEW});
      response = await doRequest({
        method: REQUEST_TYPE.DELETE,
        url: Finance.customFilterViewURL(),
        data: {id},
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: DELETE_CUSTOM_FILTER_VIEW_COMPLETED,
          payload: {id, data},
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: DELETE_CUSTOM_FILTER_VIEW_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: DELETE_CUSTOM_FILTER_VIEW_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const sendPassbookData = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: SEND_PASSBOOK_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Finance.sendPassbookDataURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: SEND_PASSBOOK_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: SEND_PASSBOOK_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: SEND_PASSBOOK_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const stpSendForApproval = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: STP_SEND_PASSBOOK_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Finance.stpSendForApprovalURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: STP_SEND_PASSBOOK_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: STP_SEND_PASSBOOK_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: STP_SEND_PASSBOOK_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const holdPartnerPassbookPayment = (requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: HOLD_PARTNER_PASSBOOK_PAYMENT});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url: Finance.holdPartnerPassbookPaymentURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: HOLD_PARTNER_PASSBOOK_PAYMENT_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: HOLD_PARTNER_PASSBOOK_PAYMENT_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: HOLD_PARTNER_PASSBOOK_PAYMENT_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const addPassbookCreditOrDebit = (type, requestData) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: ADD_PASSBOOK_CREDIT_OR_DEBIT});
      response = await doRequest({
        method: REQUEST_TYPE.POST,
        url:
          type === 'credit'
            ? Finance.addPassbookCreditURL()
            : Finance.addPassbookDebitURL(),
        data: requestData,
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: ADD_PASSBOOK_CREDIT_OR_DEBIT_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: ADD_PASSBOOK_CREDIT_OR_DEBIT_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: ADD_PASSBOOK_CREDIT_OR_DEBIT_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

//passbook balances
export const getPassbookBalancesData = (entityId) => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: GET_PASSBOOK_BALANCES_DATA});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Finance.getPassbookBalancesDataURL(entityId),
      });
      const {data, status} = response || {};
      if (status) {
        dispatch({
          type: GET_PASSBOOK_BALANCES_DATA_COMPLETED,
          payload: data,
        });
      } else {
        const {message = 'Service Error'} = response || {};
        dispatch({
          type: GET_PASSBOOK_BALANCES_DATA_FAILED,
          payload: {error: message},
        });
      }
    } catch (err) {
      dispatch({
        type: GET_PASSBOOK_BALANCES_DATA_FAILED,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const getAdjustmentSummary = (searchStr) => async (dispatch) => {
  // const { filterStr = `` } = filters || {};

  dispatch({type: GET_ADJUSTMENT_SUMMARY_REQUEST});

  try {
    const response = await doRequest({
      method: REQUEST_TYPE.GET,
      url: Finance.getAdjustmentSummaryURL(searchStr ? `${searchStr}` : ''),
    });

    const {data, status} = response || {};

    if (status) {
      dispatch({
        type: GET_ADJUSTMENT_SUMMARY_SUCCESS,
        payload: data,
      });

      return {success: true, data};
    } else {
      dispatch({
        type: GET_ADJUSTMENT_SUMMARY_FAILURE,
        error: response?.message || `Failed to fetch Adjustment Summary`,
      });

      return {
        success: false,
        message: response?.message || `Failed to fetch Adjustment Summary`,
      };
    }
  } catch (err) {
    dispatch({
      type: GET_ADJUSTMENT_SUMMARY_FAILURE,
      error: err,
    });

    return {
      success: false,
      message: err.message || 'Unexpected error occurred',
    };
  }
};

export const downloadAdjustmentSummary = () => {
  return async (dispatch) => {
    let response = {};
    try {
      dispatch({type: DOWNLOAD_ADJUSTMENT_SUMMARY_REQUEST});
      response = await doRequest({
        method: REQUEST_TYPE.GET,
        url: Finance.getAdjustmentSummaryURL('?excel=true'),
      });
      const {status} = response || {};
      if (status === true) {
        dispatch({type: DOWNLOAD_ADJUSTMENT_SUMMARY_SUCCESS});
      } else {
        const {message: error = 'Error'} = response || {};
        dispatch({
          type: DOWNLOAD_ADJUSTMENT_SUMMARY_FAILURE,
          payload: {error},
        });
      }
    } catch (err) {
      dispatch({
        type: DOWNLOAD_ADJUSTMENT_SUMMARY_FAILURE,
        payload: {error: err.message},
      });
    }
    return response;
  };
};

export const getVendorOrders = (vendor_id, page = 1) => async (dispatch) => {
  dispatch({type: GET_VENDOR_ORDERS_REQUEST});

  try {
    const response = await doRequest({
      method: REQUEST_TYPE.GET,
      url: Finance.getVendorOrdersURL(vendor_id), //finance/adjustment-summary/?vendor_id=11'
    });

    const {data, status} = response || {};

    if (status) {
      dispatch({
        type: GET_VENDOR_ORDERS_SUCCESS,
        payload: data,
      });

      return {success: true, data};
    } else {
      dispatch({
        type: GET_VENDOR_ORDERS_FAILURE,
        error: response?.message || `Failed to fetch Vendor Orders`,
      });

      return {
        success: false,
        message: response?.message || `Failed to fetch Vendor Orders`,
      };
    }
  } catch (err) {
    dispatch({
      type: GET_VENDOR_ORDERS_FAILURE,
      error: err,
    });

    return {
      success: false,
      message: err.message || 'Unexpected error occurred',
    };
  }
};

export default (state = INITIAL_STATE, action) => {
  const {type, payload} = action || {};
  switch (type) {
    case GET_EXTERNAL_PAYMENT_PARTY_COMPLETED: {
      return {
        ...state,
        externalPartyPageTotal: payload?.data?.total,
        currentExternalPartyTab: payload?.tab,
        externalPaymentRecords: payload?.data?.records,
        externalPaymentData: payload.data,
      };
    }
    case FETCH_DP_POST_DATA:
      return {
        ...state,
        dpPostFetching: true,
      };
    case DP_POST_DATA:
      return {
        ...state,
        dpPostFetching: false,
        directPayoutPostData: payload,
      };

    case FETCH_SUBMIT_POST_DATA:
      return {
        ...state,
      };
    case SUBMIT_POST_DATA:
      return {
        ...state,
        dpPostFetching: false,
      };

    case FETCH_DP_DATA:
      return {
        ...state,
        dpFetching: true,
      };
    case DP_DATA:
      return {
        ...state,
        dpFetching: false,
        directPayoutData: payload,
      };

    case DP_DATA_FAILED:
      return {
        ...state,
        dpFetching: false,
        error: payload.error,
      };

    case FETCH_PH_DATA:
      return {
        ...state,
        phFetching: true,
      };
    case PH_DATA:
      return {
        ...state,
        phFetching: false,
        payoutHistoryData: payload,
      };
    case FETCH_PH_DATA_FAILED:
      return {
        ...state,
        phFetching: false,
        error: payload.error,
      };

    case DIRECT_FETCH_PH_DATA:
      return {
        ...state,
        directPhFetching: true,
      };
    case DIRECT_PH_DATA:
      return {
        ...state,
        directPhFetching: false,
        directPayoutHistoryData: payload,
      };
    case DIRECT_PH_DATA_FAILED:
      return {
        ...state,
        directPhFetching: false,
        error: payload.error,
      };

    case DIRECT_FETCH_PH_DATA_FILTER:
      return {
        ...state,
        directPhFetchingFilter: true,
      };
    case DIRECT_PH_DATA_FILTER:
      return {
        ...state,
        directPhFetchingFilter: false,
        directPayoutHistoryDataFilter: payload,
      };
    case DIRECT_PH_DATA_FILTER_FAILED:
      return {
        ...state,
        directPhFetchingFilter: false,
        error: payload.error,
      };

    case FETCH_DATA:
      return {
        ...state,
        fetching: true,
      };
    case PAYMENT_DATA:
      return {
        ...state,
        fetching: false,
        paymentMappingData: payload,
      };

    case BILLDETAILS:
      return {
        ...state,
        billDetails: payload,
      };
    //passbook
    case FETCH_PASSBOOK_DATA:
      return {
        ...state,
        fetchingPassbookData: true,
      };
    case FETCH_PASSBOOK_DATA_COMPLETED:
      return {
        ...state,
        fetchingPassbookData: false,
        sendToPassbookData: payload,
      };
    case FETCH_PASSBOOK_DATA_FAILED:
      return {
        ...state,
        fetchingPassbookData: false,
        error: payload.error,
      };
    case SAVE_CUSTOM_FILTER_VIEW_COMPLETED: {
      const {submitted, data} = payload;
      const savedViews = data?.saved_views;
      return {
        ...state,
        sendToPassbookData: {
          ...state.sendToPassbookData,
          custom_filter_list: Array.isArray(savedViews)
            ? savedViews
            : [
                ...(state.sendToPassbookData?.custom_filter_list || []),
                {...submitted, ...(data || {})},
              ],
        },
      };
    }
    case UPDATE_CUSTOM_FILTER_VIEW_COMPLETED: {
      const {id, submitted, data} = payload;
      const savedViews = data?.saved_views;
      return {
        ...state,
        sendToPassbookData: {
          ...state.sendToPassbookData,
          custom_filter_list: Array.isArray(savedViews)
            ? savedViews
            : (state.sendToPassbookData?.custom_filter_list || []).map((view) =>
                String(view.id) === String(id)
                  ? {...view, ...submitted, ...(data || {})}
                  : view,
              ),
        },
      };
    }
    case DELETE_CUSTOM_FILTER_VIEW_COMPLETED: {
      const {id, data} = payload;
      const savedViews = data?.saved_views;
      return {
        ...state,
        sendToPassbookData: {
          ...state.sendToPassbookData,
          custom_filter_list: Array.isArray(savedViews)
            ? savedViews
            : (state.sendToPassbookData?.custom_filter_list || []).filter(
                (view) => String(view.id) !== String(id),
              ),
        },
      };
    }
    case SEND_PASSBOOK_DATA:
      return {
        ...state,
        sendToLoader: true,
      };
    case SEND_PASSBOOK_DATA_COMPLETED:
      return {
        ...state,
        sendToLoader: false,
        sendToPassbookData: {
          ...state.sendToPassbookData,
          records: payload.records,
          total: payload.total,
        },
      };
    case SEND_PASSBOOK_DATA_FAILED:
      return {
        ...state,
        sendToLoader: false,
      };
    case STP_SEND_PASSBOOK_DATA:
      return {
        ...state,
        sendToLoader: true,
      };
    case STP_SEND_PASSBOOK_DATA_COMPLETED:
      return {
        ...state,
        sendToLoader: false,
        sendToPassbookData: {
          ...state.sendToPassbookData,
          records: payload.records,
          total: payload.total,
        },
      };
    case STP_SEND_PASSBOOK_DATA_FAILED:
      return {
        ...state,
        sendToLoader: false,
      };

    case GET_REFRESH_ORDER_DETAILS_DATA:
      return {
        ...state,
        isRefreshOrderDataFetching: true,
      };
    case GET_REFRESH_ORDER_DETAILS_DATA_COMPLETED:
      return {
        ...state,
        isRefreshOrderDataFetching: false,
      };
    case GET_REFRESH_ORDER_DETAILS_DATA_FAILED:
      return {
        ...state,
        isRefreshOrderDataFetching: false,
      };

    case GET_PARTNER_PASSBOOK_DETAILS:
      return {
        ...state,
        fetchPartnerPassbookDetails: true,
      };
    case GET_PARTNER_PASSBOOK_DETAILS_SUCCESSFUL:
      return {
        ...state,
        fetchPartnerPassbookDetails: false,
        partnerPassbookData: payload,
        search: payload.search,
      };
    case GET_PARTNER_PASSBOOK_DETAILS_FAILED:
      return {
        ...state,
        fetchPartnerPassbookDetails: false,
        error: payload.error,
      };
    case ADD_PASSBOOK_CREDIT_OR_DEBIT:
      return {
        ...state,
        addingCreditOrDebit: true,
      };
    case ADD_PASSBOOK_CREDIT_OR_DEBIT_COMPLETED: {
      const newRecordsObj = payload?.passbook_record || {};
      // Convert the keyed object to an array
      const newRecordsArr = Object.values(newRecordsObj);
      return {
        ...state,
        addingCreditOrDebit: false,
        partnerPassbookData: {
          ...state.partnerPassbookData,
          passbook_record: [
            ...newRecordsArr, // prepend new record
            ...(state.partnerPassbookData?.passbook_record || []),
          ],
        },
      };
    }
    case ADD_PASSBOOK_CREDIT_OR_DEBIT_FAILED:
      return {
        ...state,
        addingCreditOrDebit: false,
        error: payload.error,
      };
    //passbook balances
    case GET_PASSBOOK_BALANCES_DATA:
      return {
        ...state,
        fetchingPassbookBalancesData: true,
      };
    case GET_PASSBOOK_BALANCES_DATA_COMPLETED:
      return {
        ...state,
        fetchingPassbookBalancesData: false,
        passbookBalancesData: payload,
        countZast: payload.zast_count || 0,
        countOnmove: payload.onmove_count || 0,
        countTransin: payload.transin_count || 0,
      };
    case GET_PASSBOOK_BALANCES_DATA_FAILED:
      return {
        ...state,
        fetchingPassbookBalancesData: false,
        error: payload.error,
      };
    case GET_ADJUSTMENT_SUMMARY_REQUEST:
      return {
        ...state,
        loadingAdjustmentSummary: true,
        error: null,
      };
    case GET_ADJUSTMENT_SUMMARY_SUCCESS:
      return {
        ...state,
        loadingAdjustmentSummary: false,
        adjustmentSummary: action.payload || [],
      };

    case GET_ADJUSTMENT_SUMMARY_FAILURE:
      return {
        ...state,
        loadingAdjustmentSummary: false,
        error: action.payload,
      };

    case DOWNLOAD_ADJUSTMENT_SUMMARY_REQUEST:
      return {
        ...state,
        downloadingAdjustmentSummary: true,
      };
    case DOWNLOAD_ADJUSTMENT_SUMMARY_SUCCESS:
      return {
        ...state,
        downloadingAdjustmentSummary: false,
      };
    case DOWNLOAD_ADJUSTMENT_SUMMARY_FAILURE:
      return {
        ...state,
        downloadingAdjustmentSummary: false,
      };

    /**
     * 🔹 Vendor Orders (Drill-down)
     */
    case GET_VENDOR_ORDERS_REQUEST:
      return {
        ...state,
        loadingVendorOrders: true,
        error: null,
      };

    case GET_VENDOR_ORDERS_SUCCESS:
      return {
        ...state,
        loadingVendorOrders: false,
        vendorOrders: action.payload || [],
      };

    case GET_VENDOR_ORDERS_FAILURE:
      return {
        ...state,
        loadingVendorOrders: false,
        error: action.payload,
      };

    default:
      return state;
  }
};
